import {useGetPortalLicensesQuery} from "../store/generated/api";

export const QUOTA_WARNING_THRESHOLD = 80;

export type QuotaWarningLevel = "none" | "warning" | "exceeded";

export function useQuotaWarning(): QuotaWarningLevel {
    const {data} = useGetPortalLicensesQuery({});

    const percentages = (data?.licenses ?? [])
        .flatMap(license => license.quotas ?? [])
        .map(quota => quota.percentageUsed ?? 0);

    if (percentages.some(percentage => percentage >= 100)) {
        return "exceeded";
    }
    if (percentages.some(percentage => percentage >= QUOTA_WARNING_THRESHOLD)) {
        return "warning";
    }
    return "none";
}
